<template lang="html">
	<div class="min-h-screen bg-background">
		<Navigation
			:scrolled="scrolled"
			@go-to-insurance="goToInsurance"
			@toggle-mobile-menu="mobileMenuOpen = !mobileMenuOpen"
			:mobileMenuOpen="mobileMenuOpen"
		/>
		<HeroSection @go-to-insurance="goToInsurance" />
		<FeaturesSection />
		<Footer />
	</div>
</template>

<script>
import Navigation from './components/home /Navigation.vue';
import HeroSection from './components/home /HeroSection.vue';
import FeaturesSection from './components/home /FeaturesSection.vue';
import Footer from './components/home /Footer.vue';

export default {
	components: {
		Navigation,
		HeroSection,
		FeaturesSection,
		Footer,
	},
	data() {
		return {
			mobileMenuOpen: false,
			scrolled: false,
		};
	},
	methods: {
		clearSession() {
			sessionStorage.clear();
		},
		goToInsurance() {
			this.clearSession();
			this.$router.push('/insurance');
		},
		handleScroll() {
			this.scrolled = window.scrollY > 50;
		},
	},
	mounted() {
		window.addEventListener('scroll', this.handleScroll);
	},
	beforeDestroy() {
		window.removeEventListener('scroll', this.handleScroll);
	},
};
</script>

<style lang="less">
.construction {
	min-height: 100vh;
	background: #fff;
}
</style>
